<section class="bg-star-gray-600 pb-[60px] lg:pb-[100px]">
  <div class="container">
    <div class="grid gap-[20px] md:grid-cols-2">
      @for (page of pages(); track page.link) {
        <div
          class="flex flex-col gap-[10px] rounded-[10px] bg-[#25282D] px-[20px] py-[24px] transition-all duration-300 ease-in hover:bg-[#2F3238]"
        >
          <a
            [routerLink]="page.link"
            class="text-[20px] font-bold leading-[1.3] text-white underline underline-offset-4"
          >
            {{ page.anchor }}
          </a>
          <p class="text-[16px] leading-[1.8] text-[#C0C0C0]">{{ page.text }}</p>
        </div>
      }
    </div>
  </div>
</section>
